<div [formGroup]="busContactForm">
    <div class="form-group row">
        <label for="buscon_last_name" class="col-md-3 col-form-label boldlbl">Last Name:</label>
        <div class="col-md-2">
            <input class="form-control form-control-sm" type="text" id="buscon_last_name" name="buscon_last_name"  formControlName="buscon_last_name" maxlength="30">
        </div>
        <label for="buscon_first_name" class="col-md-2 col-form-label boldlbl">First Name:</label>
        <div class="col-md-2">
            <input class="form-control form-control-sm" type="text" id="buscon_first_name" name="buscon_first_name" formControlName="buscon_first_name" maxlength="30">
        </div>
        <label for="buscon_title" class="col-md-1 col-form-label boldlbl">Title:</label>
        <div class="col-md-2">
            <input class="form-control form-control-sm" type="text" id="buscon_title" name="buscon_title" formControlName="buscon_title" maxlength="20">
        </div>
    </div>
    <div class="form-group row">
        <label class="col-md-3 col-form-label boldlbl">Daytime Phone Number:</label>
        <div class="d-flex col-md-6">
            <span>(</span>
            <div class="col-md-4 spacing">
                <input #phArea class="form-control form-control-sm" type="text" id="buscon_phAreaCd" name="buscon_phAreaCd" formControlName="buscon_phAreaCd"
                    (input)="onInputEntry($event, bphExch)" maxlength="3">
            </div>
            <span>)</span>
            <div class="col-md-4 spacing">
                <input #bphExch class="form-control form-control-sm" type="text" id="buscon_phExchNbr" name="buscon_phExchNbr" formControlName="buscon_phExchNbr"
                    (input)="onInputEntry($event, bphTrnk)" maxlength="3">
            </div>
            <span>-</span>
            <div class="col-md-4 spacing">
                <input #bphTrnk class="form-control form-control-sm" type="text" id="buscon_phTrnkNbr" name="buscon_phTrnkNbr" formControlName="buscon_phTrnkNbr"
                    (input)="onInputEntry($event, bphExt)" maxlength="4">
            </div>
        </div>
        <label for="buscon_phExtNbr" class="col-md-1 col-form-label boldlbl">ext.</label>
        <div class="col-md-2">
            <input #bphExt class="form-control form-control-sm" type="text" id="buscon_phExtNbr" name="buscon_phExtNbr" formControlName="buscon_phExtNbr"
                maxlength="4">
        </div>
    </div>
    <div class="row" style="margin-top: -15px!important;">
        <div class="col-md-9 offset-md-3">
            <span style="color: red;"
                *ngIf="buscon_phAreaCd.errors?.pattern && buscon_phAreaCd.touched">
                <span class="form-text">Please Correct or Remove Business Contact Phone Area Code (999 or blank).</span>
            </span>
            <span style="color: red;"
                *ngIf="!(buscon_phAreaCd.errors?.pattern && buscon_phAreaCd.touched) &&((buscon_phExchNbr.errors?.pattern && buscon_phExchNbr.touched) || (buscon_phTrnkNbr.errors?.pattern && buscon_phTrnkNbr.touched))">
                <span class="form-text">Please Correct or Remove Business Contact Phone Number.</span>
            </span>
            <span style="color: red;"
            *ngIf="buscon_phAreaCd.errors?.phnErr && buscon_phAreaCd.touched">
            <span class="form-text">Business Contact Phone number is invalid. Phone number must be complete and contain only numbers. Format '999 999-9999'.</span>
        </span>
        </div>
    </div>
    <div class="form-group row" style="margin-top: 15px!important;">
        <label for="buscon_email_addr" class="col-md-3 col-form-label boldlbl">E-mail Address:</label>
        <div class="col-md-9">
            <input class="form-control form-control-sm" type="text" id="buscon_email_addr" name="buscon_email_addr" formControlName="buscon_email_addr" maxlength="60">
            <span style="color: red;" *ngIf="buscon_email_addr.invalid && buscon_email_addr.touched">
                <span class="form-text" *ngIf="buscon_email_addr.errors?.invalidAtDot">{{errorMessages.invalidAtDot}}</span>
                <span *ngIf="buscon_email_addr.errors?.invalidEmailChar">{{errorMessages.invalidEmailChar}}</span>
                <span *ngIf="buscon_email_addr.errors?.invalidEmailDomain">{{errorMessages.invalidEmailDomain}}</span>
                <span *ngIf="buscon_email_addr.errors?.invalidEmailUserName">{{errorMessages.invalidEmailUserName}}</span>
                <span *ngIf="buscon_email_addr.errors?.invalidEmailIp">{{errorMessages.invalidEmailIp}}</span>
                <span *ngIf="buscon_email_addr.errors?.invalidDomainName">{{errorMessages.invalidDomainName}}</span>
                <span *ngIf="buscon_email_addr.errors?.invalidDomainOrCountry">{{errorMessages.invalidDomainOrCountry}}</span>
                <span *ngIf="buscon_email_addr.errors?.missingEmailHost">{{errorMessages.missingEmailHost}}</span>
            </span>
        </div>
    </div>
    <div class="form-group row" style="margin-top: 15px!important;">
        <label for="buscon_web_address" class="col-md-3 col-form-label boldlbl">Business Web Address (URL)</label>
        <div class="col-md-9">
            <input class="form-control form-control-sm" type="text" id="buscon_web_address" name="buscon_web_address" formControlName="buscon_web_address" maxlength="60">
        </div>
    </div>
</div>